import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const View = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 17 16" {...props}>
    <path
      d="M8.50002 4.06308C6.1486 4.02342 3.71669 5.66667 2.18777 7.34958C2.02729 7.52775 1.93848 7.75904 1.93848 7.99883C1.93848 8.23862 2.02729 8.46991 2.18777 8.64808C3.68344 10.2954 6.10835 11.9766 8.50002 11.9363C10.8917 11.9766 13.3172 10.2954 14.814 8.64808C14.9745 8.46991 15.0633 8.23862 15.0633 7.99883C15.0633 7.75904 14.9745 7.52775 14.814 7.34958C13.2834 5.66667 10.8514 4.02342 8.50002 4.06308Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6875 8C10.6874 8.43262 10.559 8.85549 10.3186 9.21515C10.0781 9.57481 9.73644 9.85509 9.33672 10.0206C8.93699 10.186 8.49718 10.2293 8.07288 10.1448C7.64859 10.0603 7.25887 9.85196 6.953 9.54601C6.64713 9.24006 6.43885 8.85028 6.35449 8.42596C6.27013 8.00164 6.31349 7.56184 6.47907 7.16216C6.64465 6.76248 6.92503 6.42088 7.28475 6.18054C7.64447 5.9402 8.06738 5.81192 8.5 5.81192C8.78734 5.81184 9.07187 5.86839 9.33735 5.97833C9.60282 6.08827 9.84402 6.24945 10.0472 6.45266C10.2503 6.65586 10.4114 6.89711 10.5213 7.16261C10.6312 7.42811 10.6877 7.71266 10.6875 8Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
